import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import RealNameRecords from "../components/RealNameRecords.vue";
import { typeList } from "./js/config";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  name: "city-master",
  components: {
    RealNameRecords: RealNameRecords
  },
  data: function data() {
    return {
      searchForm: {
        page: 1,
        count: 20,
        phone: this.$route.query.phone || "",
        order_by: ""
      },
      // 搜索表单

      dialogVisible: false,
      form: {
        phone: "",
        type: "city_master",
        level: "",
        remark: ""
      },
      btnCityMasterLoading: false,
      typeList: typeList,
      // 表单验证规则
      rules: {
        phone: [{
          required: true,
          message: "请输入手机号码",
          trigger: "blur"
        }, {
          min: 11,
          max: 11,
          message: "请输入正确的手机号码",
          trigger: "blur"
        }],
        type: [{
          required: true,
          message: "请选择类型",
          trigger: "change"
        }]
      },
      dialogTimeVisible: false,
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      level: {
        0: "无",
        1: "新手",
        2: "新秀",
        3: "精英"
      },
      levelList: [{
        label: "无",
        value: 0
      }, {
        label: "新手",
        value: 1
      }, {
        label: "新秀",
        value: 2
      }, {
        label: "精英",
        value: 3
      }]
    };
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      var _this = this;
      if (!val) {
        // 弹窗关闭时重置表单
        this.form = {
          phone: "",
          type: "city_master",
          level: "",
          remark: ""
        };
        this.$nextTick(function () {
          _this.$refs.cityMasterForm && _this.$refs.cityMasterForm.clearValidate();
        });
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this2.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    toLog: function toLog(row) {
      var _row$user_info, _row$user_info2;
      window.open("#/user/city-master/invitation-log?id=".concat(row.id, "&userId=").concat(row.user_id, "&userName=").concat(((_row$user_info = row.user_info) === null || _row$user_info === void 0 ? void 0 : _row$user_info.name) || ((_row$user_info2 = row.user_info) === null || _row$user_info2 === void 0 ? void 0 : _row$user_info2.phone)));
    },
    edit: function edit(row) {
      this.dialogVisible = true;
      row.phone = row.user_phone;
      this.form = JSON.parse(JSON.stringify(row));
    },
    add: function add() {
      this.dialogVisible = true;
    },
    // 结算
    settlementCityMaster: function settlementCityMaster(row) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this3.$confirm("请确认审核完成后结算?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      _context2.n = 1;
                      return _this3.$api.settlementCityMaster({
                        user_id: row.id
                      });
                    case 1:
                      // 操作上报
                      _this3.$operationLog.push({
                        code: "settlement",
                        userId: row.id,
                        operationType: "city_master",
                        detailBatchNo: row.phone
                      });
                      _this3.$message.success("操作成功");
                      _this3.getData();
                    case 2:
                      return _context2.a(2);
                  }
                }, _callee2);
              })));
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    pageChange: function pageChange(pn) {
      this.searchForm.page = pn;
      this.getData();
    },
    // 重置表格和搜索条件
    resetTable: function resetTable() {
      var _this$$refs;
      this.searchForm = {
        page: 1,
        count: 20,
        order_by: ""
      };
      // 重置表头排序样式
      (_this$$refs = this.$refs) === null || _this$$refs === void 0 || (_this$$refs = _this$$refs.table) === null || _this$$refs === void 0 || _this$$refs.clearSort();
      this.getData("search");
    },
    sortChange: function sortChange(_ref2) {
      var prop = _ref2.prop,
        order = _ref2.order;
      if (order) {
        // 根据排序方向确定是否添加负号
        this.searchForm.order_by = order === "ascending" ? prop : "-".concat(prop);
      } else {
        this.searchForm.order_by = "";
      }
      this.getData();
    },
    getData: function getData(type) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _res$data, _res$data2;
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (type === "search") {
                _this4.searchForm.page = 1;
              }
              _this4.tableLoading = true;
              _context4.n = 1;
              return _this4.$api.getCityMasterList(_this4.searchForm);
            case 1:
              res = _context4.v;
              _this4.tableData = ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.list) || [];
              _this4.total = ((_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.page.total) || 0;
              _this4.tableLoading = false;
              _this4.getUserListByIds(_this4.tableData, "user_id");
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    // 设置城市大使
    setCityMaster: function setCityMaster() {
      var _this5 = this;
      this.$refs.cityMasterForm.validate(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(valid) {
          var _this5$form, _this5$form2, res;
          return _regenerator().w(function (_context5) {
            while (1) switch (_context5.n) {
              case 0:
                if (!valid) {
                  _context5.n = 6;
                  break;
                }
                _this5.btnCityMasterLoading = true;
                _context5.n = 1;
                return _this5.$api.getUserList({
                  phone: _this5.form.phone
                });
              case 1:
                res = _context5.v;
                if (!(!res.data.list || res.data.list.length === 0)) {
                  _context5.n = 2;
                  break;
                }
                _this5.$message.error("未找到该手机号对应的用户");
                _this5.btnCityMasterLoading = false;
                return _context5.a(2);
              case 2:
                if (!((_this5$form = _this5.form) !== null && _this5$form !== void 0 && _this5$form.id)) {
                  _context5.n = 4;
                  break;
                }
                _context5.n = 3;
                return _this5.$api.updateCityMaster(_this5.form);
              case 3:
                _context5.n = 5;
                break;
              case 4:
                _context5.n = 5;
                return _this5.$api.createCityMaster(_this5.form);
              case 5:
                // 操作上报
                _this5.$operationLog.push({
                  code: (_this5$form2 = _this5.form) !== null && _this5$form2 !== void 0 && _this5$form2.id ? "update" : "add",
                  userId: _this5.form.user_id,
                  operationType: "user",
                  detailBatchNo: res.data.list[0].id
                });
                _this5.$message.success(_this5.form.id ? "修改成功" : "新增成功");
                _this5.dialogVisible = false;
                _this5.getData();
                _this5.btnCityMasterLoading = false;
              case 6:
                return _context5.a(2);
            }
          }, _callee5);
        }));
        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    // 取消城市大使
    deleteItem: function deleteItem(row) {
      var _this6 = this;
      this.$confirm("取消， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return _this6.$api.updateCityMaster({
                phone: row.user_phone,
                user_id: row.user_id,
                status: 0
              });
            case 1:
              // 操作上报
              _this6.$operationLog.push({
                code: "cancel",
                userId: row.id,
                operationType: "user",
                detailBatchNo: row.id
              });
              _this6.$message.success("操作成功");
              _this6.getData();
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))).catch(function () {});
    }
  }
};